componentRegistryInstance.register('xlate', 'read', 'hrd.components.form.XlateComponent');

hrd.components.form.XlateComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.XlateComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	getReadOnlyField: function(field, name, object, options) {
		let skip = !!field.data('skip-to-object');
		if (!skip) {
			this.setValueByPath(object, name, field.text());
		}
	},
	setReadOnlyField: function(field, value, object, options) {
		let key = field.data('key');
		if (key != undefined) {
			if (field.data('useDataAsArgs')) {
				field.html(xlate(key, object));
			} else if (field.data('useAsArgs')) {
				field.html(xlate(key, field.data('useAsArgs')));
			} else {
				field.html(xlate(key));
			}
		} else {
			field.html(xlate(value));
		}
	}
});